/* Water Test Report page: fetch the tokenized report JSON from
   water-test-report-worker and render Problem -> Fix -> Contact Aidan
   with the full lab results collapsed at the bottom. */
(function () {
  "use strict";

  var cfg = window.WaterTestReportConfig || {};
  var root = document.getElementById("wtr-report");
  var loading = document.getElementById("wtr-loading");
  var errorBox = document.getElementById("wtr-error");
  if (!root || !loading || !errorBox) return;

  var AIDAN_PHOTO = "https://cdn.shopify.com/s/files/1/0278/9523/4605/files/aidan_profile.jpg?v=1772765157";

  function esc(s) {
    return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }

  function fmtDate(iso) {
    if (!iso) return "";
    try {
      return new Date(iso).toLocaleDateString("en-US", { year: "numeric", month: "long", day: "numeric" });
    } catch (e) {
      return "";
    }
  }

  function firstName(name) {
    return String(name || "").trim().split(/\s+/)[0] || "";
  }

  function showError() {
    loading.style.display = "none";
    root.style.display = "none";
    errorBox.style.display = "block";
  }

  /* ---------- measurement ---------- */

  // GA4 lives behind GTM here, and a bare gtag('event') fans the hit out to the
  // Google Ads and Merchant Center destinations too (verified on this page).
  // send_to keeps report events in Analytics where they belong.
  var GA4_ID = "G-TTSFX2Z51P";

  // Never include the report token: it is the credential for this page, and
  // analytics URLs get shared, exported, and retained.
  function track(name, params) {
    var payload = { send_to: GA4_ID };
    if (params) for (var k in params) payload[k] = params[k];
    try { if (window.gtag) window.gtag("event", name, payload); } catch (e) {}
    try { if (window.clarity) window.clarity("event", name); } catch (e) {}
  }

  // Which CTA was clicked, resolved by the element's own class. Ordered because
  // the fix button and the contact button share .wtr-btn-aidan.
  var CTA_MATCHERS = [
    [".wtr-btn-fix", "fix_recommend"],
    [".wtr-fixin-link--under", "fix_collection"],
    [".wtr-allclear-link", "allclear_panels"],
    [".wtr-fixin-link", "watch_collection"],
    [".wtr-headlink--sms", "header_sms"],
    [".wtr-headlink--call", "header_call"],
    [".wtr-aidan .wtr-btn-aidan", "contact_sms"],
    [".wtr-aidan .wtr-btn-alt", "contact_call"],
    [".wtr-original", "original_pdf"],
  ];

  function ctaName(el) {
    for (var i = 0; i < CTA_MATCHERS.length; i++) {
      if (el.closest(CTA_MATCHERS[i][0])) return CTA_MATCHERS[i][1];
    }
    return null;
  }

  /* ---------- renderers ---------- */

  function evidenceHtml(evidence) {
    if (!evidence || !evidence.length) return "";
    var items = evidence
      .map(function (e) {
        // Avoid "pH: 5.8 pH" -- drop a unit that just repeats the name.
        var display = String(e.display || "");
        var dupUnit = new RegExp("\\s*" + String(e.name || "").replace(/[.*+?^${}()|[\]\\]/g, "\\$&") + "$", "i");
        display = display.replace(dupUnit, "");
        // A found/not-found result gets a colored status dot; a measured number
        // stays neutral, since the card copy already says whether it's too high.
        var flat = display.trim().toLowerCase();
        var cls = "";
        if (flat === "present") cls = " class=\"wtr-ev-hit\"";
        else if (flat === "absent" || flat === "not detected") cls = " class=\"wtr-ev-clear\"";
        return (
          "<li" + cls + "><span>" + esc(e.name) + ": " + esc(display) +
          (e.limit_label ? "<small>" + esc(e.limit_label) + "</small>" : "") +
          "</span></li>"
        );
      })
      .join("");
    return '<ul class="wtr-evidence">' + items + "</ul>";
  }

  function videoHtml(video) {
    if (!video || !video.id) return "";
    return (
      '<div class="wtr-video">' +
      '<button type="button" class="wtr-video-thumb" data-video-id="' + esc(video.id) + '" aria-label="Play video: ' + esc(video.title) + '">' +
      '<img src="https://i.ytimg.com/vi/' + esc(video.id) + '/hqdefault.jpg" alt="" loading="lazy" decoding="async">' +
      '<span class="wtr-video-play"><span><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M8 5v14l11-7z"/></svg></span></span>' +
      "</button>" +
      '<p class="wtr-video-title">' + esc(video.title) + "</p>" +
      "</div>"
    );
  }

  // Split a summary into a one-sentence lede (which carries the highlighted
  // reading) and the rest (the why-it-matters paragraph under it). Guards
  // against splitting on "E. coli" and on very short openers by requiring a
  // capital letter after the break and a minimum lede length.
  function splitLede(text) {
    var s = String(text || "").trim();
    var re = /([.!?])\s+(?=[A-Z])/g;
    var m;
    while ((m = re.exec(s))) {
      var idx = m.index + 1;
      var head = s.slice(0, idx);
      if (head.length < 25) continue;
      if (/(^|\s)[A-Za-z]\.$/.test(head)) continue;
      return { lede: head, rest: s.slice(idx).trim() };
    }
    return { lede: s, rest: "" };
  }


  // Highlight the customer's own number inside the lede sentence and follow it
  // with what normal looks like, so the reading has context without a second
  // component. Units that follow the number get pulled into the highlight
  // ("9.48 grains per gallon"), and if the number isn't in the sentence the
  // baseline still renders on its own.
  var UNIT_AFTER = "(?:\\s*(?:grains per gallon|grains|parts per million|PPM|ppm|mg/L|ug/L|NTU|gpg|pH))?";

  function firstNumber(text) {
    return (String(text || "").match(/-?\d+(?:\.\d+)?/) || [])[0] || null;
  }

  // Wrap the first occurrence of `phrase` in the highlight tint. Matches against
  // the raw sentence, not the escaped one, so the tag can never land inside an
  // entity like &#39; and break it.
  function tint(raw, phrase) {
    var i = raw.toLowerCase().indexOf(String(phrase || "").toLowerCase());
    if (!phrase || i < 0) return null;
    return (
      esc(raw.slice(0, i)) +
      '<b class="wtr-hl">' + esc(raw.slice(i, i + phrase.length)) + "</b>" +
      esc(raw.slice(i + phrase.length))
    );
  }

  // Returns the lede with the customer's own number highlighted, plus the
  // baseline. `matched` tells the caller the number is visible in the sentence,
  // so the duplicate evidence chip can be dropped. The baseline is skipped when
  // the sentence already names it ("well above the 0.2 PPM guideline").
  //
  // Present/absent findings have no number, so the substance itself gets the
  // tint ("The lab found <coliform bacteria>"). Those never set `matched`: the
  // chip carries the Present/Absent verdict, which the sentence doesn't repeat.
  function ledeHtml(lede, reading, highlight) {
    var raw = String(lede || "");
    var html = esc(raw);
    var matched = false;
    if (!reading) return { html: tint(raw, highlight) || html, matched: false };

    var num = firstNumber(reading.display);
    if (num) {
      // Match against the raw sentence, not the escaped one, so a number can
      // never land inside an entity like &#39; and break it.
      var m = raw.match(new RegExp("(^|[^\\d.])(" + num.replace(".", "\\.") + UNIT_AFTER + ")"));
      if (m) {
        matched = true;
        var start = m.index + m[1].length;
        html =
          esc(raw.slice(0, start)) +
          '<b class="wtr-hl">' + esc(m[2]) + "</b>" +
          esc(raw.slice(start + m[2].length));
      }
    }

    // Standalone match only: "7" must not count as found inside "27.6".
    var baseNum = firstNumber(reading.baseline);
    var inLede =
      baseNum && new RegExp("(^|[^\\d.])" + baseNum.replace(".", "\\.") + "(?![\\d.])").test(lede);
    if (!inLede) html += ' <span class="wtr-baseline">' + esc(reading.baseline) + "</span>";
    return { html: html, matched: matched };
  }

  // Same filled check circle as the all-clear card, so "solved" looks the same
  // everywhere on the page.
  var FIX_CHECK =
    '<svg class="wtr-fixin-check" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">' +
    '<path fill-rule="evenodd" clip-rule="evenodd" d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25zm4.28 7.97a.75.75 0 0 0-1.06-1.06l-4.97 4.97-1.97-1.97a.75.75 0 1 0-1.06 1.06l2.5 2.5a.75.75 0 0 0 1.06 0l5.5-5.5z"/></svg>';

  function icon(paths) {
    return (
      '<svg class="wtr-cardhead-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" ' +
      'stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
      paths +
      "</svg>"
    );
  }

  var TIERS = {
    act_now: {
      label: "Fix this now",
      order: 0,
      icon: icon('<path d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/><path d="M12 9v4"/><path d="M12 17h.01"/>'),
    },
    worth_fixing: {
      label: "Worth fixing",
      order: 1,
      icon: icon('<path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"/>'),
    },
    watch: {
      label: "Keep an eye on",
      order: 2,
      icon: icon('<path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/>'),
    },
  };

  // One card per problem, and the card says everything: how urgent it is
  // (colored band), what it is, the reading, why it matters, the lab values,
  // and the fix -- all in the open, nothing behind a tap.
  // Watch-tier cards are deliberately quieter: no video, no big green button.
  function problemCard(p, opts) {
    var tier = TIERS[p.severity] || TIERS.watch;
    var isWatch = p.severity === "watch";

    var hasFix = !!(p.fix && p.fix.url);
    var dupFix = hasFix && opts.seenFixes[p.fix.url];
    if (hasFix && !dupFix) opts.seenFixes[p.fix.url] = true;
    if (hasFix && !dupFix) opts.showedFix = true;

    var split = splitLede(p.summary);
    var lede = ledeHtml(split.lede, p.reading, p.highlight);
    // The headline reading now lives in the sentence, so its chip would just
    // repeat it. Only drop the chip when the highlight actually landed.
    var ev = (p.evidence || []).slice(lede.matched ? 1 : 0);

    // Why it matters used to hide behind a tap. It's one or two sentences and
    // it's the reason the customer should care, so it reads straight through
    // under the reading instead.
    var why = split.rest ? '<p class="wtr-problem-why">' + esc(split.rest) + "</p>" : "";

    // The video sits inside the fix panel under "The fix: UV Disinfection
    // System", so the equipment video is the one that belongs there. The
    // problem explainer is the fallback for keys with no equipment video
    // (nitrate, manganese) and is what plays on cards with no fix panel.
    var fixVideo = dupFix ? null : p.fix && p.fix.video;
    var video = isWatch ? null : fixVideo || p.video || null;

    // The video belongs to the fix, not to the problem: Aidan explaining the
    // problem is the setup for the solution, so it sits inside the fix panel
    // above the description instead of floating between the two.
    var fixHtml = "";
    var loose = "";
    if (dupFix) {
      loose = videoHtml(video);
      fixHtml =
        '<div class="wtr-fixin"><p class="wtr-fixin-dup">The ' + esc(p.fix.label.toLowerCase()) +
        " above fixes this too. One system, both problems.</p></div>";
    } else if (hasFix && isWatch) {
      fixHtml =
        '<div class="wtr-fixin">' +
        '<p class="wtr-fixin-optional">No equipment needed. If you ever want to fix it:</p>' +
        '<a class="wtr-fixin-link" href="' + esc(p.fix.url) + '">' +
        esc(p.fix.cta || "See the systems") +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 6l6 6-6 6"/></svg></a>' +
        "</div>";
    } else if (hasFix) {
      // Sizing a system takes the well's flow rate, the household, and the
      // order of treatment, so Aidan speccing it beats the customer picking
      // from a collection. The collection link stays as the quieter second
      // option for anyone who wants to read specs and prices first.
      fixHtml =
        '<div class="wtr-fixin">' +
        '<p class="wtr-fixin-label">' + FIX_CHECK + "The fix</p>" +
        '<p class="wtr-fixin-title">' + esc(p.fix.label) + "</p>" +
        videoHtml(video) +
        '<p class="wtr-fixin-blurb">' + esc(p.fix.blurb) + "</p>" +
        '<a class="wtr-btn wtr-btn-aidan wtr-btn-fix" href="' + opts.recommendHref + '">' +
        SMS_SVG + "<span>Ask Aidan What I Need</span></a>" +
        '<a class="wtr-fixin-link wtr-fixin-link--under" href="' + esc(p.fix.url) + '">' +
        esc(p.fix.cta || "See the systems") +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 6l6 6-6 6"/></svg></a>' +
        "</div>";
    } else if (!isWatch) {
      // Some findings have no off-the-shelf product because the right fix
      // depends on where the reading is coming from (aluminum, zinc, a censored
      // lab result). Those summaries tell the customer to text Aidan, so the
      // card has to give them something to tap instead of leaving the
      // instruction with no button attached to it.
      //
      // A missing lab result is the one case where "the fix" is the wrong word:
      // there is nothing in the water to treat and nothing to size. What that
      // customer needs is a retest.
      var noResult = p.key === "no_result";
      loose =
        videoHtml(video) +
        '<div class="wtr-fixin">' +
        '<p class="wtr-fixin-label">' + FIX_CHECK + (noResult ? "What happens next" : "The fix") + "</p>" +
        '<p class="wtr-fixin-blurb">' +
        (noResult
          ? "Aidan will get a replacement kit out to you so you get the answer you paid for."
          : "This one depends on where it is coming from, so Aidan will size it with you.") +
        "</p>" +
        '<a class="wtr-btn wtr-btn-aidan wtr-btn-fix" href="' + opts.recommendHref + '">' +
        SMS_SVG + "<span>" + (noResult ? "Text Aidan About This" : "Ask Aidan What I Need") + "</span></a>" +
        "</div>";
    } else {
      loose = videoHtml(video);
    }

    // Cards ship closed so the report opens as a scannable list of findings.
    // The closed row has to earn the tap on its own, so it carries the urgency
    // band, the problem, the customer's own number, and the name of the fix.
    // A native <details> gives keyboard support and the open/close state for
    // free, and it keeps the video thumbnail from loading until it's needed.
    var chip = (p.reading && p.reading.display) || (p.evidence && p.evidence[0] && p.evidence[0].display) || "";
    var namesFix = hasFix && !isWatch;
    var sumFix = namesFix
      ? '<span class="wtr-sumfix">' + FIX_CHECK + "Fix: " + esc(p.fix.label) + "</span>"
      : "";

    return (
      '<details class="wtr-card wtr-card--' + esc(p.severity) +
      '" data-key="' + esc(p.key) + '" data-severity="' + esc(p.severity) + '">' +
      '<summary class="wtr-cardsum">' +
      '<span class="wtr-cardhead">' + tier.icon + "<span>" + esc(tier.label) + "</span></span>" +
      '<span class="wtr-sum">' +
      '<span class="wtr-sumtop">' +
      '<h2 class="wtr-problem-title">' + esc(p.title) + "</h2>" +
      '<svg class="wtr-sumchev" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 9l6 6 6-6"/></svg>' +
      "</span>" +
      (chip ? '<span class="wtr-sumchip">' + esc(chip) + "</span>" : "") +
      sumFix +
      '<span class="wtr-sumopen">' + (namesFix ? "Tap to see the fix" : "Tap for details") + "</span>" +
      "</span></summary>" +
      '<div class="wtr-cardbody">' +
      '<p class="wtr-problem-lede">' + lede.html + "</p>" +
      why +
      evidenceHtml(ev) +
      loose +
      fixHtml +
      "</div></details>"
    );
  }

  function problemGroups(problems, smsUrl) {
    var opts = {
      seenFixes: {},
      showedFix: false,
      recommendHref: smsUrl,
    };
    var sorted = (problems || []).slice().sort(function (a, b) {
      return (TIERS[a.severity] || TIERS.watch).order - (TIERS[b.severity] || TIERS.watch).order;
    });
    return sorted
      .map(function (p) { return problemCard(p, opts); })
      .join("");
  }

  // A clean single-issue kit (lead + copper, hydrogen sulfide) only earns the
  // claim it measured, so the card names what was tested and points at the
  // full panel instead of telling the customer their water is fine.
  function allClearCard(interp) {
    var cov = (interp && interp.coverage) || {};
    var narrow = !!(cov.narrow && cov.label);
    // Engine 13+: results the lab could not measure low enough to compare with
    // the limit. The card may only vouch for what the lab could measure.
    var unmeasured = (interp && interp.not_low_enough) || [];
    var title = unmeasured.length
      ? "No problems in what the lab could measure"
      : narrow ? "No " + esc(cov.label_or || cov.label) + " problems" : "Your water looks great";
    var cantTell = unmeasured.length
      ? (unmeasured.length === 1 ? "One result" : unmeasured.length + " results") +
        " could not be measured low enough to compare with the EPA limit; " +
        (unmeasured.length === 1 ? "it is" : "they are") +
        " marked \u201cCan\u2019t tell\u201d in your full results below. "
      : "";
    var text = narrow
      ? (unmeasured.length ? "Every result the lab could measure came back where it should be. " : "Every result came back where it should be. ") +
        cantTell +
        "This test covered " +
        esc(cov.label) +
        " only, so it is not a full picture of your water. A full panel also checks bacteria, metals, and minerals."
      : unmeasured.length
        ? "Every result the lab could measure came back where it should be. " + cantTell +
          "Wells and plumbing change over time, so retest once a year and keep this report as your baseline."
        : "Every result came back where it should be. No equipment needed. Wells and plumbing change over time, so retest once a year and keep this report as your baseline.";
    return (
      '<div class="wtr-card wtr-allclear">' +
      '<svg class="wtr-allclear-icon" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path fill-rule="evenodd" clip-rule="evenodd" d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25zm4.28 7.97a.75.75 0 0 0-1.06-1.06l-4.97 4.97-1.97-1.97a.75.75 0 1 0-1.06 1.06l2.5 2.5a.75.75 0 0 0 1.06 0l5.5-5.5z"/></svg>' +
      '<h2 class="wtr-allclear-title">' + title + "</h2>" +
      '<p class="wtr-allclear-text">' + text + "</p>" +
      (narrow
        ? '<a class="wtr-allclear-link" href="https://midatlanticwater.net/collections/water-testing">See full test panels</a>'
        : "") +
      "</div>"
    );
  }

  // The token deliberately STAYS in the address bar: it is the only credential
  // for the page, so stripping it would break refresh (bare URL = error state)
  // and address-bar sharing (spouse, plumber). Accepted trade-off: the token
  // reaches GA4/Clarity page-URL fields. Never add it to custom event params.
  function reportUrl() {
    return window.location.origin + window.location.pathname + "?t=" + encodeURIComponent(token);
  }

  // One prefill for every Text Aidan button on the page. Whichever one the
  // customer taps, Aidan gets the same thing: the link to the exact report, and
  // on a report with findings, the list itself so he can answer from the thread
  // without opening anything. Half of all reports need two or more systems in a
  // specific order, so the list is the whole report rather than one problem.
  function aidanSms(problems, status) {
    var list = status === "problems" ? problems || [] : [];
    var body;
    if (list.length) {
      var lines = list.slice(0, 8).map(function (p) {
        var reading = p.reading && p.reading.display ? " (" + p.reading.display + ")" : "";
        return "- " + p.title + reading;
      });
      var extra = list.length - lines.length;
      if (extra > 0) lines.push("- plus " + extra + " more in the report");
      body =
        "Hi Aidan, my water test came back and I'd like your recommendation on what system I need.\n\n" +
        "What the lab found:\n" + lines.join("\n") +
        "\n\nMy report: " + reportUrl();
    } else {
      // Watch-only and all-clear reports have nothing to recommend against, so
      // asking "what system do I need" would put words in the customer's mouth.
      body = "Hi Aidan, my water test results just came in. Can we go over them?\n\nMy report: " + reportUrl();
    }
    return "sms:" + esc(cfg.smsNumber) + "?&body=" + encodeURIComponent(body);
  }

  // Matches snippets/custom-chat-trigger.liquid: 8am-5pm ET, seven days a week.
  // That snippet is hidden on this layout, so the report page carries its own copy.
  function isBusinessHours() {
    try {
      var et = new Date(new Date().toLocaleString("en-US", { timeZone: "America/New_York" }));
      var hour = et.getHours();
      return hour >= 8 && hour < 17;
    } catch (e) {
      return true;
    }
  }

  var SMS_SVG =
    '<svg viewBox="0 0 32 32" fill="currentColor" aria-hidden="true"><path d="M16 4C8.27 4 2 9.37 2 16c0 3.27 1.54 6.22 4.04 8.34-.13 1.4-.69 3.42-1.94 5.06-.27.36-.04.87.41.83 2.55-.24 5.39-1.16 7.5-2.36C13.27 28.34 14.61 28 16 28c7.73 0 14-5.37 14-12S23.73 4 16 4z"/></svg>';
  var PHONE_SVG =
    '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M6.62 10.79a15.05 15.05 0 006.59 6.59l2.2-2.2a1 1 0 011.01-.24 11.36 11.36 0 003.58.57 1 1 0 011 1V20a1 1 0 01-1 1A17 17 0 013 4a1 1 0 011-1h3.5a1 1 0 011 1 11.36 11.36 0 00.57 3.58 1 1 0 01-.25 1.01l-2.2 2.2z"/></svg>';

  // Contact pills under the report line. The page exists to get the customer
  // talking to Aidan, so both ways to reach him are pressable before any
  // results are read.
  function headLinks(smsUrl) {
    return (
      '<p class="wtr-headlinks">' +
      '<a class="wtr-headlink wtr-headlink--sms" href="' + smsUrl + '" aria-label="Text Aidan at ' + esc(cfg.smsDisplay) + '">' +
      SMS_SVG + "Text Aidan</a>" +
      '<a class="wtr-headlink wtr-headlink--call" href="tel:' + esc(cfg.phoneNumber) + '">' +
      PHONE_SVG + "Call " + esc(cfg.phoneDisplay) + "</a>" +
      "</p>"
    );
  }

  // On a report with findings this is the next step, not a help desk: the
  // customer knows what is wrong and still cannot buy without sizing, order of
  // treatment, and the right model. On an all-clear report there is no next
  // step, so the same section goes back to being an open door.
  function contactSection(smsUrl, status) {
    var online = isBusinessHours();
    var allClear = status === "all_clear";
    var title = allClear ? "Questions? Ask Aidan." : "Your next step: talk to Aidan.";
    var body = allClear
      ? "He reads every report personally. If a number here doesn\u2019t make sense, just ask."
      : "Send him your report. He\u2019ll tell you exactly what to buy, sized for your household, or that you don\u2019t need anything.";
    var reassure = "Free, no sales pitch, never a bother.";
    return (
      '<div class="wtr-card wtr-aidan">' +
      '<span class="wtr-aidan-avatar">' +
      '<img class="wtr-aidan-photo" src="' + AIDAN_PHOTO + '" alt="Aidan, Mid Atlantic Water" width="84" height="84" loading="lazy" decoding="async">' +
      '<span class="wtr-status-dot ' + (online ? "is-online" : "is-offline") + '" aria-hidden="true"></span>' +
      "</span>" +
      '<h3 class="wtr-aidan-title">' + title + "</h3>" +
      '<p class="wtr-aidan-presence">' +
      '<span class="wtr-presence-state' + (online ? "" : " is-away") + '">' +
      (online ? "Online now" : "Away right now") +
      "</span>" +
      '<span class="wtr-presence-sep" aria-hidden="true">&middot;</span>' +
      "<span>" + (online ? "Replies 7 days a week, 8am-5pm ET" : "Back at 8am ET") + "</span>" +
      "</p>" +
      '<p class="wtr-aidan-text">' + body + "</p>" +
      '<p class="wtr-aidan-reassure">' + reassure + "</p>" +
      '<a class="wtr-btn wtr-btn-aidan" href="' + smsUrl + '" aria-label="Text Aidan at ' + esc(cfg.smsDisplay) + '">' +
      SMS_SVG + "Text Aidan</a>" +
      '<a class="wtr-btn wtr-btn-alt" href="tel:' + esc(cfg.phoneNumber) + '">' +
      PHONE_SVG + "Call " + esc(cfg.phoneDisplay) + "</a>" +
      "</div>"
    );
  }

  // The lab sometimes cannot put a number on a reading and returns its own
  // string instead ("> 333"). That is a measurement, so print it verbatim
  // rather than falling back to a blank cell.
  function rowValue(d) {
    var v = d.qualitative != null && d.qualitative !== "" ? d.qualitative : d.value;
    if (v == null || v === "") return "&mdash;";
    return esc(v) + (d.unit ? " " + esc(d.unit) : "");
  }

  function fullResults(interp) {
    var rows = "";
    (interp.detected || []).forEach(function (d) {
      // over_limit is tri-state: true = proven over, false = proven within,
      // null = a censored result that proves neither. No pill on null; a
      // "Within limit" verdict the lab never proved would be a lie.
      var status = "";
      // low_enough === false (engine 13+): the lab's floor sits above the limit
      // ("under 2" against 0.3), so the honest verdict is that we cannot tell.
      var cantTell = d.low_enough === false;
      if (cantTell) status = '<span class="wtr-pill wtr-pill--unknown">Can\u2019t tell</span>';
      else if (d.limit_label) {
        if (d.over_limit === true) status = '<span class="wtr-pill wtr-pill--over">Over limit</span>';
        else if (d.over_limit === false) status = '<span class="wtr-pill wtr-pill--ok">Within limit</span>';
      }
      var floor =
        cantTell && d.reporting_limit != null
          ? '<small class="wtr-floor">The lab can\u2019t measure below ' + esc(d.reporting_limit) + (d.unit ? " " + esc(d.unit) : "") + "</small>"
          : "";
      rows +=
        '<tr class="' + (d.over_limit === true ? "wtr-row-over" : "") + '">' +
        "<td>" + esc(d.name) + (d.limit_label ? "<small>" + esc(d.limit_label) + "</small>" : "") + floor + "</td>" +
        "<td>" + rowValue(d) + "</td>" +
        "<td>" + status + "</td>" +
        "</tr>";
    });
    (interp.informational || []).forEach(function (d) {
      rows +=
        "<tr><td>" + esc(d.name) + "<small>Normal mineral / index reading</small></td>" +
        "<td>" + rowValue(d) + "</td><td></td></tr>";
    });

    // Engine 13+ sends each non-detect's reporting limit ("under 0.2 PPM").
    // Engine 12 payloads have only the names, and render as before.
    var ndDetail = {};
    (interp.non_detect_detail || []).forEach(function (x) {
      if (x && x.name && x.display) ndDetail[x.name] = x.display;
    });
    var hasDetail = Object.keys(ndDetail).length > 0;
    var hasAbsent = Object.keys(ndDetail).some(function (k) { return ndDetail[k] === "Absent"; });
    var nd = (interp.non_detect || [])
      .map(function (n) {
        return (
          '<li><svg class="wtr-nd-check" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path fill-rule="evenodd" clip-rule="evenodd" d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25zm4.28 7.97a.75.75 0 0 0-1.06-1.06l-4.97 4.97-1.97-1.97a.75.75 0 1 0-1.06 1.06l2.5 2.5a.75.75 0 0 0 1.06 0l5.5-5.5z"/></svg>' +
          "<span>" + esc(n) + (ndDetail[n] ? ' <span class="wtr-nd-under">' + esc(ndDetail[n]) + "</span>" : "") + "</span></li>"
        );
      })
      .join("");

    // Kept deliberately separate from the green-checked list above. The lab
    // never answered on these, and "no result" must never read as "clean".
    var nr = (interp.no_result || [])
      .map(function (n) {
        return (
          '<li><svg class="wtr-nr-mark" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path fill-rule="evenodd" clip-rule="evenodd" d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25zM12 7a1 1 0 0 1 1 1v5a1 1 0 1 1-2 0V8a1 1 0 0 1 1-1zm0 10.5a1.15 1.15 0 1 0 0-2.3 1.15 1.15 0 0 0 0 2.3z"/></svg>' +
          esc(n) + "</li>"
        );
      })
      .join("");

    var notes = (interp.notes || [])
      .map(function (n) { return "<li>" + esc(n) + "</li>"; })
      .join("");

    return (
      '<details class="wtr-details">' +
      "<summary>See your full lab results" +
      '<svg class="wtr-chev" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 9l6 6 6-6"/></svg>' +
      "</summary>" +
      '<div class="wtr-details-body">' +
      '<p class="wtr-results-note">Results from an accredited lab in SimpleLab\u2019s network. Values compared to EPA limits where one exists.</p>' +
      '<table class="wtr-table"><thead><tr><th>What we tested</th><th>Your result</th><th></th></tr></thead><tbody>' +
      rows +
      "</tbody></table>" +
      (nd
        ? '<h4 class="wtr-subhead">Tested for and NOT found (' + (interp.non_detect || []).length + ")</h4>" +
          (hasDetail
            ? '<p class="wtr-results-note">Each numeric result was below the smallest amount the lab can measure, shown beside it.' +
              (hasAbsent ? " Bacteria tests show Absent." : "") + "</p>"
            : "") +
          '<ul class="wtr-nd-list">' + nd + "</ul>"
        : "") +
      (nr
        ? '<h4 class="wtr-subhead">No result reported (' + (interp.no_result || []).length + ")</h4>" +
          '<p class="wtr-results-note">The lab listed these but never returned a reading, so we cannot tell you they were clean. Text Aidan and we will sort it out.</p>' +
          '<ul class="wtr-nd-list wtr-nr-list">' + nr + "</ul>"
        : "") +
      (notes ? '<ul class="wtr-notes">' + notes + "</ul>" : "") +
      "</div></details>"
    );
  }

  // The worker's URL, never SimpleLab's: their signed PDF links expire in about a week.
  function originalReport(data) {
    if (!data.original_report_url) return "";
    return (
      '<a class="wtr-original" href="' + esc(data.original_report_url) + '" target="_blank" rel="noopener">' +
      '<svg class="wtr-original-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z"/></svg>' +
      '<span class="wtr-original-text">' +
      '<span class="wtr-original-title">The lab\u2019s original report (PDF)</span>' +
      '<span class="wtr-original-sub">SimpleLab\u2019s PDF with every result, the test methods and detection limits, and the lab that ran your sample.</span>' +
      "</span>" +
      '<svg class="wtr-original-go" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M13.5 6H5.25A2.25 2.25 0 0 0 3 8.25v10.5A2.25 2.25 0 0 0 5.25 21h10.5A2.25 2.25 0 0 0 18 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25"/></svg>' +
      "</a>"
    );
  }

  function render(data) {
    var interp = data.interpretation || {};
    var problems = interp.problems || [];
    var name = firstName(data.customer_name);
    var testedDate = fmtDate(data.approved_at || data.order_date);

    var html = "";
    var smsUrl = aidanSms(problems, interp.status);

    // Header
    html +=
      '<div class="wtr-head">' +
      '<h1 class="wtr-title">' +
      (name ? esc(name) + ", your " : "Your ") +
      "water test results are in." +
      "</h1>" +
      '<p class="wtr-meta">' + esc(data.package_name || "Water Test") +
      (testedDate ? " &middot; " + esc(testedDate) : "") +
      " &middot; Report " + esc(data.external_id) + "</p>" +
      headLinks(smsUrl) +
      "</div>";

    // What we found: one self-contained block per problem, grouped by urgency
    if (interp.status === "all_clear") {
      html += allClearCard(interp);
    } else {
      html += problemGroups(problems, smsUrl);
    }

    // Contact Aidan
    html += contactSection(smsUrl, interp.status);

    // Full results (collapsed)
    html += fullResults(interp);
    html += originalReport(data);

    root.innerHTML = html;
    loading.style.display = "none";
    root.style.display = "block";

    track("wtr_report_view", {
      wtr_status: interp.status || "",
      wtr_package: data.package_name || "",
      wtr_problems: problems.length,
      wtr_act_now: problems.filter(function (p) { return p.severity === "act_now"; }).length,
    });

    // Which findings people actually open, and how far they get.
    root.querySelectorAll("details.wtr-card").forEach(function (card) {
      card.addEventListener("toggle", function () {
        if (!card.open) return;
        track("wtr_card_open", {
          wtr_problem: card.getAttribute("data-key") || "",
          wtr_severity: card.getAttribute("data-severity") || "",
        });
      });
    });

    // The page's theory is video first, then contact. This is the video half.
    root.addEventListener("click", function (e) {
      var cta = ctaName(e.target);
      if (!cta) return;
      var card = e.target.closest("details.wtr-card");
      track("wtr_cta_click", {
        wtr_cta: cta,
        wtr_problem: card ? card.getAttribute("data-key") || "" : "",
        wtr_status: interp.status || "",
      });
    });

    // Click-to-play video swap
    root.querySelectorAll(".wtr-video-thumb").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var id = btn.getAttribute("data-video-id");
        var card = btn.closest("details.wtr-card");
        track("wtr_video_play", {
          wtr_video_id: id || "",
          wtr_problem: card ? card.getAttribute("data-key") || "" : "",
        });
        var wrap = btn.parentElement;
        var iframe = document.createElement("iframe");
        iframe.src = "https://www.youtube-nocookie.com/embed/" + encodeURIComponent(id) + "?autoplay=1&rel=0";
        iframe.allow = "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture";
        iframe.allowFullscreen = true;
        iframe.title = "YouTube video";
        wrap.replaceChild(iframe, btn);
      });
    });
  }

  /* ---------- boot ---------- */

  var params = new URLSearchParams(window.location.search);
  var token = (params.get("t") || params.get("token") || "").trim();

  if (!token || !cfg.endpoint) {
    showError();
    return;
  }

  // Without this a hung request leaves the customer on the spinner forever, and
  // the loading state has no way to reach Aidan. The error state does, so time
  // out into it rather than waiting on a request that is not coming back.
  var ctl = window.AbortController ? new AbortController() : null;
  var timedOut = false;
  var timer = setTimeout(function () {
    timedOut = true;
    if (ctl) ctl.abort();
    showError();
  }, 15000);

  fetch(cfg.endpoint.replace(/\/$/, "") + "/report?t=" + encodeURIComponent(token), {
    headers: { Accept: "application/json" },
    signal: ctl ? ctl.signal : undefined,
  })
    .then(function (resp) { return resp.json().then(function (body) { return { ok: resp.ok, body: body }; }); })
    .then(function (r) {
      if (timedOut) return;
      clearTimeout(timer);
      // A response missing its interpretation would otherwise render as a
      // cheerful, empty report. Treat a half-built payload as a failure so the
      // customer gets the error state, which tells them how to reach us.
      var interp = r.ok && r.body && r.body.ok && r.body.data && r.body.data.interpretation;
      if (!interp || !interp.status || !Array.isArray(interp.problems)) {
        showError();
        return;
      }
      render(r.body.data);
    })
    .catch(function () {
      if (timedOut) return;
      clearTimeout(timer);
      showError();
    });
})();
